import ApiURL from "../componets/ApiURL";
export const service = {
  login,
  getRole,
  googleLogin,
  createUser,
  deleteLead,
  getCampaignTable,
  seeCampaignLeads,
  showTotalLeadsInCampaign,
  getCostumerTable,
  getLeadTable,
  getLeadInCampagin,
};
const roleId = localStorage.getItem("roleId"); 

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      switch (response.status) {
        case 401:
          console.error("incorect email or password");
          return Promise.reject({ ...data, statusCode: 401 });
        case 409:
          return Promise.reject({ ...data, statusCode: 409 });
        case 404:
          return Promise.reject(data);
        default:
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function login(email, password) {
  const requestOptions = {
    method: "Get",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    ApiURL + `/users?email=${email}?password=${password}`,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      if (!res.length === 0) {
        getRole(email);
      }
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getRole(mail) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/users?email=${mail}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length !== 0) {
        localStorage.setItem("role", res[0].id_player_roles[0].name);
        localStorage.setItem("roleId", res[0].id_player_roles[0].id);
        window.location.assign("/");
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function googleLogin(account) {
  var mail = account.email;
  const requestOptions = {
    method: "Get",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/users?email=${mail}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length === 0) {
        createUserGoogle(account);
      } else {
        getRole(res[0].email);
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function createUserGoogle(account) {
  var mail = account.email;
  var name = account.given_name;
  var surname = account.family_name;
  const requestOptions = {
    method: "Post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: mail,
      password: "google",
      name: name,
      surname: surname,
      player_role: "4",
    }),
  };
  fetch(ApiURL + "/users", requestOptions)
    .then(handleResponse)
    .then(() => {
      window.location.assign("/");
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function createUser(name, surname, email, password) {
  const requestOptions = {
    method: "Post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: name,
      surname: surname,
      email: email,
      password: password,
      player_role: "4",
    }),
  };
  fetch(ApiURL + "/users", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (!res.length === 0) {
        window.location.assign("/login");
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function deleteLead(id) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/leads/${id}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.status === 200) {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getCampaignTable() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + "/campaigns", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function seeCampaignLeads(name) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    ApiURL + `/leads?_limit=-1&id_campaign.name=${name}`,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function showTotalLeadsInCampaign() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/leads?_limit=-1`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getCostumerTable() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + "/costumers", requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getLeadTable() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    ApiURL + `/campaigns?player_roles_id_in=${roleId}`,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function getLeadInCampagin(value) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(ApiURL + `/leads?id_campaign.name=${value}`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      if (res.length > 0) {
        return res;
      }
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}
